import { useState } from "react"
import { AVATAR_COUNT, getAvatarStyle } from "../game/sprites"

interface AvatarSelectScreenProps {
  onChoose: (index: number) => void
  onBack: () => void
}

/**
 * Shown once, between "New Game" and waking in Dawnmere: the player picks the
 * face they will carry through every loop. The choice is stored in permanent
 * state, so it survives death like everything else that is truly theirs.
 */
export function AvatarSelectScreen({ onChoose, onBack }: AvatarSelectScreenProps) {
  const [selected, setSelected] = useState<number | null>(null)

  return (
    <div className="screen avatar-select-screen">
      <h1>Choose Your Face</h1>
      <p className="subtitle">
        The one you wake as, every morning you have already lived.
      </p>

      <div className="avatar-grid">
        {Array.from({ length: AVATAR_COUNT }, (_, index) => (
          <button
            key={index}
            type="button"
            className={`avatar-choice${selected === index ? " avatar-choice-selected" : ""}`}
            aria-pressed={selected === index}
            aria-label={`Avatar ${index + 1}`}
            onClick={() => setSelected(index)}
            onDoubleClick={() => onChoose(index)}
          >
            <span className="avatar-sprite" style={getAvatarStyle(index)} />
          </button>
        ))}
      </div>

      <div className="menu-actions">
        <button
          type="button"
          disabled={selected === null}
          onClick={() => selected !== null && onChoose(selected)}
        >
          Begin
        </button>
        <button type="button" onClick={onBack}>
          Back
        </button>
      </div>
    </div>
  )
}
